import { render, staticRenderFns } from "./GenericComponent.vue?vue&type=template&id=65d59bd5&"
import script from "./GenericComponent.ts?vue&type=script&lang=ts&"
export * from "./GenericComponent.ts?vue&type=script&lang=ts&"
import style0 from "./GenericComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports